<template>
  <div
    pa-2
    class="header"
    style="background: white; position: sticky; top: 0; z-index: 1000"
  >
    <v-app-bar
      :style="
        $vuetify.breakpoint.name == 'lg'
          ? 'height:130px'
          : $vuetify.breakpoint.name == 'md'
          ? 'height:180px'
          : $vuetify.breakpoint.name == 'sm'
          ? 'height:150px'
          : ''
      "
      class="hidden-sm-and-down"
      color="white"
    >
      <v-layout wrap justify-start hidden-sm-and-down fill-height>
        <v-flex xs1 pl-7>
          <v-img
            width="80px"
            height="80px"
            contain
            src="./../../assets/appheaderlogo.png"
          ></v-img>
        </v-flex>
        <v-flex xs10 md10 pl-2 pt-2>
          <span text-center class="titlefont111" style="color: green"
            >Forest </span
          ><span class="titlefont111" style="color: green"
            >Development Agency,&nbsp;Thiruvananthapuram<br
          /></span>
          <span class="titlefont111" style="color: green"> Forest</span
          ><span class="titlefont111" style="color: green"> Division,</span
          ><span class="titlefont111" style="color: green"
            >&nbsp;Thiruvananthapuram</span
          >
        </v-flex>
        <v-flex xs1 pl-7>
          <v-img
            width="80px"
            height="80px"
            contain
            src="./../../assets/appheaderlogo.png"
          ></v-img>
        </v-flex>

        <v-flex xs12>
          <v-layout wrap>
            <v-flex xs12 md12 lg12>
              <ul class="main-navigation">
                <li v-for="(item, i) in headerItems" :key="i" text-right>
                  <v-btn
                    class="btn nsbold"
                    @click="$router.push({ path: item.route })"
                    text
                    tile
                    v-if="!item.dropdown"
                  >
                    <!-- style="item.title=='home'? 'background-color:red'" -->
                    <v-layout wrap
                      ><v-flex text-right>
                        <span style="font-size: 12px" class="subtitlefont2">
                          {{ item.title }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-btn>
                  <v-btn class="btn helvetica" text tile v-else>
                    <span style="font-size: 12px">
                      {{ item.title
                      }}<v-icon x-small style="color: grey"
                        >mdi-chevron-down</v-icon
                      >
                    </span>
                  </v-btn>
                  <ul
                    v-if="item.dropdown"
                    class="text-left"
                    style="
                      background-color: grey;
                      border-bottom: 6px solid #8bc34a;
                      border-top: 6px solid #8bc34a;
                    "
                  >
                    <li
                      v-for="(item2, i2) in item.dropdown"
                      :key="i2"
                      style="border-bottom: 2px solid #e0e0e0"
                    >
                      <v-btn
                        class="nsbold"
                        @click="$router.push({ path: item2.route })"
                        text
                        style="text-transform: none"
                        tile
                      >
                        <span class="subtitlefont2" style="font-size: 12px">
                          {{ item2.title }}
                          <v-icon
                            small
                            style="color: white"
                            v-if="item2.submenu"
                            >mdi-chevron-right</v-icon
                          >
                          <!--  -->
                        </span>
                      </v-btn>
                      <ul
                        v-if="item2.submenu"
                        style="
                          background-color: grey;
                          border-bottom: 6px solid #8bc34a;
                          border-top: 6px solid #8bc34a;
                        "
                      >
                        <li
                          v-for="(item3, i3) in item2.submenu"
                          :key="i3"
                          style="border-bottom: 2px solid #e0e0e0"
                        >
                          <v-btn
                            class="nsbold"
                            @click="$router.push({ path: item3.route })"
                            text
                            style="text-transform: none"
                            tile
                            v-if="!item3.submenu"
                          >
                            <span class="subtitlefont2" style="font-size: 12px">
                              {{ item3.title }}
                              <v-icon
                                small
                                style="color: white"
                                v-if="item3.submenu2"
                                >mdi-chevron-right</v-icon
                              >
                              <!--  -->
                            </span>
                          </v-btn>
                          <v-btn
                            class="nsbold"
                            @click="thirdLayer(item3)"
                            text
                            style="text-transform: none"
                            tile
                            v-else
                          >
                            <span class="helvetica" style="font-size: 12px">
                              {{ item3.title }}
                              <v-icon
                                small
                                style="color: white"
                                v-if="item3.submenu2"
                                >mdi-chevron-right</v-icon
                              >
                            </span>
                          </v-btn>
                          <ul
                            v-if="item3.submenu2"
                            style="
                              background-color: grey;
                              border-bottom: 6px solid #8bc34a;
                              border-top: 6px solid #8bc34a;
                            "
                          >
                            <li
                              v-for="(item4, i4) in item3.submenu2"
                              :key="i4"
                              style="border-bottom: 2px solid #e0e0e0"
                            >
                              <v-btn
                                class="nsbold"
                                @click="$router.push({ path: item4.route })"
                                text
                                style="text-transform: none"
                                tile
                                v-if="!item4.submenu2"
                              >
                                <span
                                  class="subtitlefont2"
                                  style="font-size: 12px"
                                >
                                  {{ item4.title }}
                                </span>
                              </v-btn>
                              <v-btn
                                class="nsbold"
                                @click="thirdLayer(item4)"
                                text
                                style="text-transform: none"
                                tile
                                v-else
                              >
                                <span class="helvetica" style="font-size: 12px">
                                  {{ item4.title }}
                                </span>
                              </v-btn>
                            </li>
                          </ul>
                        </li>
                      </ul>
                      <!-- </v-flex>
                      </v-layout> -->
                    </li>
                  </ul>
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app-bar>
    <v-app-bar class="hidden-md-and-up">
      <v-layout wrap>
        <v-flex xs12 align-self-center>
          <v-layout wrap>
            <v-flex xs1 pt-2>
              <v-app-bar-nav-icon @click="nav = true"></v-app-bar-nav-icon>
            </v-flex>
            <v-flex xs2 pl-7 pt-1
              ><v-img
                width="50px"
                height="50px"
                contain
                src="./../../assets/appheaderlogo.png"
              ></v-img
            ></v-flex>
            <v-flex xs9 pl-4>
              <span style="font-size: 9px">
                Forest Development Agency,Thiruvananthapuram Forest Division
                Thiruvananthapuram
              </span>
            </v-flex>
          </v-layout>
          <v-navigation-drawer
            height="650px"
            width="300px"
            absolute
            temporary
            v-model="nav"
          >
            <v-layout class="menufont1" wrap justify-center>
              <v-flex xs12>
                <v-list dense nav>
                  <v-list-group
                    :value="true"
                    v-for="(item, i) in headerItems"
                    :key="i"
                  >
                    <template v-slot:activator>
                      <v-btn
                        text
                        tile
                        @click="$router.push({ path: item.route })"
                      >
                        <v-list-item-title>
                          <span style="font-size: 12px">
                            {{ item.title }}
                          </span>
                        </v-list-item-title>
                      </v-btn>
                    </template>

                    <v-list-group
                      :value="true"
                      no-action
                      sub-group
                      v-for="(sub, i) in item.dropdown"
                      :key="i"
                    >
                      <template v-slot:activator>
                        <v-list-item-content>
                          <v-btn
                            class="nsbold"
                            @click="$router.push({ path: sub.route })"
                            text
                            style="text-transform: none"
                            tile
                          >
                            <v-list-item-title>
                              <span style="font-size: 12px">
                                {{ sub.title }}</span
                              >
                            </v-list-item-title>
                          </v-btn>
                        </v-list-item-content>
                      </template>
<!-- 
                      <v-list-item
                        v-for="(title, i) in sub.submenu"
                        :key="i"
                        link
                        dense
                      >
                        <v-btn
                          class="nsbold"
                          @click="$router.push({ path: title.route })"
                          text
                          style="text-transform: none"
                          tile
                        >
                          <v-list-item-title class="text-align:right">
                            <span style="font-size: 12px">
                              {{ title.title }}
                            </span></v-list-item-title
                          >
                        </v-btn>
                        <v-list-item-icon>
                          <v-icon></v-icon>
                        </v-list-item-icon>
                      </v-list-item> -->
                      
                      <v-list-group
                      :value="true"
                      no-action
                      sub-group
                      v-for="(title, i) in sub.submenu"
                      :key="i"
                    >
                      <template v-slot:activator>
                        <v-list-item-content>
                          <v-btn
                            class="nsbold"
                            @click="$router.push({ path: title.route })"
                            text
                            style="text-transform: none"
                            tile
                          >
                            <v-list-item-title>
                              <span style="font-size: 12px">
                                {{ title.title }}</span
                              >
                            </v-list-item-title>
                          </v-btn>
                        </v-list-item-content>
                      </template>
                        <v-list-item
                        v-for="(sublist, p) in title.submenu2"
                        :key="p"
                        link
                        dense
                      >
                        <v-btn
                          class="nsbold"
                          @click="$router.push({ path: sublist.route })"
                          text
                          style="text-transform: none"
                          tile
                        >
                          <v-list-item-title class="text-align:right">
                            <span style="font-size: 12px">
                              {{ sublist.title }}
                            </span></v-list-item-title
                          >
                        </v-btn>
                        <v-list-item-icon>
                          <v-icon></v-icon>
                        </v-list-item-icon>
                      </v-list-item>
                      </v-list-group>
                    </v-list-group>
                  </v-list-group>
                </v-list>
              </v-flex>
            </v-layout>
          </v-navigation-drawer>
        </v-flex>
      </v-layout>
    </v-app-bar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      phone: null,
      nav: true,
      password: null,
      value: [],
      items: [
        "Introduction",
        "Vision & Mision",
        "  Organisation Structure",
        "Who;s who",
        "Human Resources",
      ],
      items1: [
        "Profile-DIVISION PROFILE",
        "Flora",
        "  Fauna",
        "Forest Area ",
        "Forest Types",
        "Forest Management",
      ],
      items2: [
        "Introduction",
        "Vision & Mision",
        "  Organisation Structure",
        "Who;s who",
        "Human Resources",
      ],
      items3: [
        "Introduction",
        "Vision & Mision",
        "  Organisation Structure",
        "Who;s who",
        "Human Resources",
      ],
      offset: true,
      third: false,
      headerItems: [
        {
          title: "Home",
          // route: "/aboutUs",
          route: "/",
        },
        {
          title: "About us",
          // route: "/aboutUs",
          name: "About us",
          dropdown: [
            {
              title: "Introduction",
              route: "/page3",
              name: "NextPage3",
            },

            {
              title: "Vision & Mission",
              route: "/page4",
              name: "MisionVisionPage",
            },

            {
              title: "Organisation Structure",
              route: "/page5",
              name: "OrganisationStructurePage",
            },
            {
              title: "Who's who",
              route: "/page10",
              name: "Who's who",
            },
            {
              title: "Human Resources",
              // route: "/HumanResources",
              name: "Human Resources",
              submenu: [
                // {
                //   title: "Transfer and Posting",
                //   route: "/page32",
                // },
                {
                  title: "Staff Strength",
                  // route: "/page33",
                },
              ],
            },

            {
              title: "Vanasree",
              route: "/page12",
              name: "Vanasree",
            },
          ],
        },
        {
          title: "Forest",
          name: "Forest",
          dropdown: [
            {
              title: "Profile-DIVISION PROFILE",
              route: "/page41",
              name: "AboutDivisionPage",
            },
            {
              title: "Flora",
              route: "/page14",
              name: "Flora",
            },
            {
              title: "Fauna",
              route: "/page15",
              name: "Fauna",
            },
            {
              title: "Forest Area",
              route: "/page16",
              name: "Forest Area",
            },
            {
              title: "Forest Types",
              route: "/page17",
              name: "Forest Types",
            },
            {
              title: "Forest Management",
              name: "Forest Management",
              submenu: [
                {
                  title: "Working Plans ",
                  route: "/page7",
                },
              ],
            },
            {
              title: "Timbers of Kerala-Search",
              route: "/page19",
              name: "Timbers of Kerala-Search",
            },
            {
              title: "Tribal Settlements",
              route: "/page18",
              name: "Tribal Settlements",
            },
          ],
        },

        {
          title: "PFM",
          name: "PFM",
          dropdown: [
            {
              title: "Institutions",
              name: "Institutions",
              submenu: [
                {
                  title: "VSS", //pdf
                  route: "/page35",
                },

                {
                  title: "FDA", //pdf
                  route: "/page39",
                },
              ],
            },
            {
              title: "Guidelines", //pdf
              route: "/page21",
            },

            {
              title: "Schemes & Projects", //pdf
              route: "/page40",
            },
          ],
        },

        {
          title: "Public Interface",
          name: "Public Interface",
          dropdown: [
            {
              title: "Publications",
              name: "Publications",
              submenu: [
                {
                  title: "Publications ",
                  route: "/page22",
                },
                {
                  title: "Brochures ",
                  route: "/page23",
                },
              ],
            },

            {
              title: "Services",
              name: "Services",
              submenu: [
                {
                  title: "Research Studies or Internships",
                  route: "/page38",
                },
                {
                  title: "Nature Camps",
                  route: "/page36",
                },
                {
                  title: "Victims of Wildlife attack ",
                  // route: "/victims",
                },
                {
                  title: "Film Shooting",
                  route: "/page37",
                },
                {
                  title: "Right to Information",
                  route: "/page50",
                },
                {
                  title: "Right to Service",
                  submenu2: [
                    // {
                    //   title: "Transfer and Posting",
                    //   route: "/page32",
                    // },
                    {
                      title: "Saw Mill",
                      route: "/page48",
                    },
                    {
                      title: "Land Relates NOC's",
                      route: "/page49",
                    },
                  ],
                },
              ],
            },
            {
              title: "Timber",
              // route: "/",
              name: "Timber",
              submenu: [
                {
                  title: "Scheduled Rates ",
                  route: "/PAGE26",
                },
                {
                  title: "Seigniorage Rates ",
                },
                {
                  title: "Dumping Depots",
                  // route: "/whosWho",
                },
              ],
            },
            {
              title: "Price Schedule  Miscellaneous Items",
              // route: "/", //pdfpage 51

              route: "/page51",

              name: "Price Schedule  Miscellaneous Items",
            },
            // {
            //   title: "Captive Elephats Data",
            //   route: "/",
            //   name: "Captive Elephats Data",
            // },
            {
              title: "Contract System",
              route: "/page52",

              // name: "Contract System",
            },
          ],
        },

        {
          title: "Downloads",
          name: "Downloads",
          dropdown: [
            {
              title: "Codes & Manuals",
              route: "/page34",
              name: "Codes & Manuals",
            },
            {
              title: "Policies, Circulars, Guidelines",
              // route: "/",
              name: "Policies,Circulars,Guidelines",
              submenu: [
                {
                  title: "Policies",
                  route: "/page24",
                },
                {
                  title: "Circulars",
                  route: "/page25",
                },
                {
                  title: "Guidelines",
                  route: "/page21",
                },
                {
                  title: "SOPs",
                  route: "/page20",
                },
              ],
            },

            {
              title: "Ecorestoration Policy",
              // route: "/",
              // name: "Ecorestoration Policy",

              submenu: [
                {
                  title: "Malayalam ",
                  // route: "/Ecorestoration Policy",
                },
                {
                  title: "English ",
                  // route: "/Ecorestoration Policy",
                },
              ],
            },

            {
              title: "Departmental Use",
              // route: "/",
              name: "Departmental Use",
              submenu: [
                {
                  title: "Application Forms",
                  route: "/page27",
                },
                {
                  title: "Volume Table ",
                  route: "/page28",
                },
              ],
            },
          ],
        },
        {
          title: "Contact Us",
          route: "/",
          name: "Contact Us",
          dropdown: [
            {
              title: "Mobile Phone Index & Email",
              route: "/page29",
              name: "Mobile Phone Index & Email",
            },
            {
              title: "Telephone Directory",
              route: "/page30",
              name: "Telephone Directory",
            },
            {
              title: "Contact address",
              route: "/page31",
              name: "Headquarters EPABX No.",
            },
          ],
        },

        {
          title: "Ecotourism",
          // route: "/",
          name: "Ecotourism",
          dropdown: [
            {
              title: "Details of Ecotourism",
              route: "/page45",
              name: "Ecotourism",
            },
          ],
        },
        {
          title: "Staff Corner",
          // route: "/",
          name: "Ecotourism",
          dropdown: [
            {
              title: "Transfer & Posting",
              route: "/page32",
            },
            {
              title: "Government Orders",
              route: "/page47",
            },
          ],
        },
        {
          title: "TENDERS",
          // route: "/aboutUs",
          route: "/page46",
        },
      ],
    };
  },
  methods: {
    thirdLayer(item) {
      this.third = true;
      console.log(item);
    },
  },
};
</script>

<style >
ul {
  list-style: none;
  padding: 0;
  margin: 0;
  background: #ffffff;
}
ul li {
  display: block;
  position: relative;
  float: left;
  /* background: #1bc2a2; */
}
li ul {
  display: none;
}
ul li a {
  display: block;
  padding: 1em;
  text-decoration: none;
  white-space: nowrap;
  color: #fff;
}
ul li a:hover {
  background: #2c3e50;
}
li:hover > ul {
  display: block;
  position: absolute;
}
li:hover li {
  float: none;
}
li:hover a {
  background: #1bc2a2;
}
li:hover li a:hover {
  background: #2c3e50;
}
.main-navigation li ul li {
  border-top: 0;
}
ul ul ul {
  left: 100%;
  top: 0;
}
ul:before,
ul:after {
  content: " "; /* 1 */
  display: table; /* 2 */
}
ul:after {
  clear: both;
}
</style>
